import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

interface TwoFactorSettingsStateProps {
    fetching: boolean;
    loading: boolean;
    activated?: boolean;

    secret?: string;
    imageUrl?: string;

    showModal: boolean;
}
export class TwoFactorSettingsState extends Record<TwoFactorSettingsStateProps>({
    fetching: false,
    loading: false,
    activated: undefined,

    secret: undefined,
    imageUrl: undefined,

    showModal: false,
}) {}

export default makeReducer<TwoFactorSettingsState>(
    [
        match(Actions.getTwoFactorImage, state =>
            state.merge({
                fetching: true,
            }),
        ),
        match(Actions.getTwoFactorImageSuccess, (state, {payload}) =>
            state.merge({
                fetching: false,
                secret: payload.secret,
                imageUrl: payload.imageUrl,
            }),
        ),
        match(Actions.getTwoFactorImageFailed, state =>
            state.merge({
                fetching: false,
            }),
        ),
        match(Actions.activateTwoFactor, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(Actions.activateTwoFactorSuccess, state =>
            state.merge({
                loading: false,
                activated: true,
                showModal: false,
            }),
        ),
        match(Actions.activateTwoFactorFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.disableTwoFactor, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(Actions.disableTwoFactorSuccess, state =>
            state.merge({
                loading: false,
                activated: false,
                showModal: false,
            }),
        ),
        match(Actions.disableTwoFactorFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(
            Actions.showModal,
            () =>
                new TwoFactorSettingsState({
                    showModal: true,
                }),
        ),
        match(Actions.hideModal, state =>
            state.merge({
                showModal: false,
            }),
        ),
    ],
    new TwoFactorSettingsState(),
);
